import { NgFor, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogRef } from '@angular/material/dialog'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatStepperModule } from '@angular/material/stepper'
import { ToastrService } from 'ngx-toastr'
import { AddressService } from '../../services/address/address.service'
import { Address, AddressDTO } from '../../models/location.interface'
import { HttpErrorResponse } from '@angular/common/http'
import { territories } from '../incident-observatorio/incident-form/incident.definitions'

@Component({
    selector: 'app-address-form',
    standalone: true,
    imports: [
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgIf,
        NgFor,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    templateUrl: './address-form.component.html',
    styleUrl: './address-form.component.css',
})
export class AddressFormComponent {
    selectedAddress: Address | null = null
    addressId: string | null = null
    errorMsg: string[] | null = null
    territories = territories

    constructor(
        private dialogRef: MatDialogRef<AddressFormComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private addressService: AddressService
    ) {}

    ngOnInit(): void {
        this.addressService.$addressSelected.subscribe((address) => {
            if (address) {
                this.addressId = String(address.id)
                this.selectedAddress = address
                this.editAddressForm.patchValue({
                    ...address,
                })
            }
        })
    }

    editAddressForm = this.fb.group({
        authority: ['', []],
        authorityCode: [0, []],
        complement: ['', []],
        number: ['', []],
        street: ['', []],
        territory: ['', []],
        territoryCode: [0, []],
    })

    closeDialog() {
        this.dialogRef.close()
    }

    updateAddress() {
        const payload = this.editAddressForm.value as AddressDTO
        if (this.editAddressForm.status === 'VALID' && this.addressId) {
            if (this.editAddressForm.pristine) {
                this.dialogRef.close()
                return
            }
            const id = Number(this.addressId)
            this.addressService
                .updateAddress(id, { ...payload, id: id })
                .subscribe({
                    next: (location) => {
                        const msg = `El registro fue EDITADO correctamente!`
                        this.toastr.success(msg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.dialogRef.close()
                    },
                    error: ({}: HttpErrorResponse) => {
                        if (this.errorMsg) {
                            this.toastr.error(
                                'Error: ' + this.errorMsg,
                                undefined,
                                {
                                    progressBar: true,
                                    timeOut: 5000,
                                }
                            )
                        }
                    },
                })
        }
    }
}
